var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsulting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.294,352.008c-10.907-10.925-17.615-25.87-17.633-42.462v-61.795H0v61.795 c0.017,49.544,40.23,89.738,89.765,89.774h40.532v-29.67H89.765C73.164,369.641,58.236,362.933,47.294,352.008z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.931,165.076c21.636,0,39.145-17.508,39.145-39.154c0-21.609-17.508-39.153-39.145-39.153 c-21.619,0-39.154,17.544-39.154,39.153C46.777,147.567,64.312,165.076,85.931,165.076z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.166,298.47h-54.926v-81.758c0-21.165-17.135-38.318-38.308-38.318c-21.147,0-38.299,17.152-38.299,38.318 v93.146c0,21.155,17.143,38.308,38.299,38.308c2.873,0,70.024-0.195,70.024-0.195l3.674,56.688 c0.259,11.61,9.884,20.818,21.494,20.568c11.628-0.258,20.827-9.883,20.56-21.494l2.233-80.512 C203.916,309.537,192.84,298.47,179.166,298.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M482.34,247.751v61.795c-0.018,16.592-6.726,31.538-17.633,42.462c-10.943,10.925-25.87,17.633-42.462,17.642 h-40.541v29.67h40.541c49.526-0.036,89.73-40.23,89.756-89.774v-61.795H482.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M426.069,165.076c21.618,0,39.154-17.508,39.154-39.154c0-21.609-17.536-39.153-39.154-39.153 c-21.636,0-39.145,17.544-39.145,39.153C386.924,147.567,404.433,165.076,426.069,165.076z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.378,309.857v-93.146c0-21.165-17.17-38.318-38.308-38.318c-21.173,0-38.308,17.152-38.308,38.318v81.758 h-54.926c-13.674,0-24.75,11.067-24.75,24.75l2.233,80.512c-0.267,11.611,8.932,21.236,20.56,21.494 c11.61,0.25,21.236-8.959,21.494-20.568l3.674-56.688c0,0,67.15,0.195,70.024,0.195 C447.225,348.165,464.378,331.012,464.378,309.857z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.651,
    y: 248.124,
    className: "st0",
    width: 212.386,
    height: 36.147
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.048,
    y: 303.673,
    className: "st0",
    width: 24.714,
    height: 87.497
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsulting);
export default __webpack_public_path__ + "static/media/consulting.8b031f04.svg";
export { ForwardRef as ReactComponent };